import Logo from "../assets/img/Logo_launch_capital.svg";
import Poweredby from "../assets/img/BackrrFullGrey.png";
import favicon from "../assets/img/Launch-capital-favicon.png";

const Initial = {
  branding: {
    favicon:favicon,
    logo: Logo,
    poweredbylogo: Poweredby,
  },
  app:{
    iosApp:"https://apps.apple.com/in/app/launch-capital/id6741749717",
    androidApp:"https://play.google.com/store/apps/details?id=com.lcaf"
  },
  organization:{
    title:"Launch Capital",
    sub_title:"My Launch Capital",
    name:"LCAF"
  },
  theme: {
    mainColor:"#f7aa1d",    //set the button color 
  },
  api:{
    baseUrl:""
  }
};

// Inject CSS variables directly into the document head
const setCSSVariables = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      --main-color: ${Initial.theme.mainColor};
    }
  `;
  document.head.appendChild(style);
};

// Call the function to apply styles
setCSSVariables();
window.Initial = Initial;

export default Initial;
